var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-td',{attrs:{"justifyContent":"options.align"}},[_vm._v(" "+_vm._s(_vm.model)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }